<div class="mfa-container" fxLayout="row"  fxLayoutAlign="center center">
    <mat-card class="mat-card-sty" data-loader="mfa-loader">
      <div class="mfa-box">     
   <div class="login-header">
    <div class="row">
      <img class="logo_image" src="assets/img/logo/Transcriber_Logo.png" style="width:100%">
    </div> 
    <div class="login-sub-head">Welcome to Transcriber</div>   
        </div> 
    <div *ngIf="!isError" class="mfa-head">Enter MFA 6 digit code that you have received <br> on your registered device.</div>
    <div *ngIf="isError" class="mfa-err-head">The MFA 6 digit code that you have entered <br> is not correct. Please check again.</div>
        <form  [formGroup]="mfaForm" #aForm>
        <div class="login-content" fxLayout="column">
          <div class="form-group-header">
          <div class="mfa-digits-block">
            <mat-form-field  floatLabel="never" appearance="outline" class="width-16">
              <input class="inp-sty"  formControlName="digit1" name="digit1"  matInput  (keyup)="keytab($event,'digit1','digit1','digit2')" > 
            </mat-form-field>
            <mat-form-field  floatLabel="never" appearance="outline" class="width-16">
                <input class="inp-sty" formControlName="digit2" name="digit2" matInput (keyup)="keytab($event,'digit1','digit2','digit3')" > 
              </mat-form-field>
            <mat-form-field  floatLabel="never" appearance="outline" class="width-16">
                <input class="inp-sty" formControlName="digit3" name="digit3" matInput  (keyup)="keytab($event,'digit2','digit3','digit4' )"> 
            </mat-form-field>
            <mat-form-field  floatLabel="never" appearance="outline" class="width-16">
                <input class="inp-sty" formControlName="digit4" name="digit4"  matInput (keyup)="keytab($event,'digit3','digit4','digit5')"> 
            </mat-form-field>
            <mat-form-field  floatLabel="never" appearance="outline" class="width-16">
                <input class="inp-sty" formControlName="digit5" name="digit5"  matInput (keyup)="keytab($event,'digit4','digit5','digit6')" > 
            </mat-form-field>
            <mat-form-field  floatLabel="never" appearance="outline" class="width-16">
                <input class="inp-sty" formControlName="digit6" name="digit6" matInput (keyup)="keytab($event,'digit5','digit6',null)" > 
            </mat-form-field>
        </div>
      </div>  
        </div>
    </form>
    </div>
    <div class="form-group-header" style="display:flex;justify-content: space-between;">
        <div class="form-group linkk">
              <a class="nav-link" (click)="gotoLoginPage($event)">Back to Login</a> 
        </div>
        <div class="form-group linkk">
            <a class="nav-link" (click)="regenerateQRCode($event)">Regenerate QR Code</a> 
      </div>
    </div>
  </mat-card>
  </div>
  